import React from 'react';

import { OptimizedImage } from './OptimizedImage';

const InControlSection = () => {
  return (
    <div className="teat-bg">
      <div className="section-item def-w-max">
        <div className="row mgn-top-50">
          <div className="col-12 col-sm-6">
            <div className="txt-wrap-sect pdd-rt-50">
              <h2 className="mgn-bot-30 sectionAlignment">You’re always in control.</h2>
              <p className="para-txt">
                Subscription is all about the convenience of not having to think
                about buying your dog’s food. We want to make it easy and we
                certainly don’t want to lock you into anything!
              </p>
              <div className="tick-list">
                <ul>
                  <li>
                    Skip, pause, change or cancel your orders any time you like
                    with absolutely no questions or penalties... in fact we’d
                    love to help you!
                  </li>
                  <li>
                    We’ll always remind you 3 days before we process your next
                    order so you can make any changes you need.
                  </li>
                  <li>
                    Your dashboard gives you all the information you need about
                    how much to feed, when your next order is due and how to
                    track orders.
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="col-12 col-sm-6">
            <div className="img-wrap-sect op-img-w-100">
              <OptimizedImage fileName="hiw_img_3.png" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InControlSection;
